import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { AngularFireDatabase } from 'angularfire2/database';
import { AuthService } from '../../service/auth.service';
import * as CryptoJS from 'crypto-js';
import { ToastrService } from 'ngx-toastr';
import { Auth } from '../../service/auth';

@Component({
	selector: 'app-admin-edit-student',
	templateUrl: './admin-edit-student.component.html',
	styleUrls: ['./admin-edit-student.component.css']
})
export class AdminEditStudentComponent implements OnInit {

	submitted = false;
	editStudentForm: FormGroup;

	StateList: Auth[];
	order: string = 'state';
	reverse: boolean = false;
	
	encryptMode: boolean;
	encryptPswdR: string;
	dencryptPswdL: string;

	constructor(private fb: FormBuilder,
		public router: Router,
		private actRoute: ActivatedRoute,
		public db: AngularFireDatabase,
		public authService: AuthService,
		public toastr: ToastrService) {
		this.encryptMode = true;
	}

	ngOnInit() {
		$('.toggle-password').click(function () {

			$(this).toggleClass("fa-eye fa-eye-slash");
			var input = $($(this).attr("toggle"));
			if (input.attr("type") == "password") {
				input.attr("type", "text");
			} else {
				input.attr("type", "password");
			}
		});
		const id = this.actRoute.snapshot.paramMap.get('id');
		this.authService.GetStudent(id).valueChanges().subscribe(data => {
			this.editStudentForm.setValue(data)
			this.editStudentForm.controls['password'].setValue(CryptoJS.AES.decrypt(this.password.value.trim(), this.email.value.trim()).toString(CryptoJS.enc.Utf8));
		})
		this.userRegister();
		this.getState();
	}

	getState() {
		const s = this.authService.getStateList();
		s.snapshotChanges().subscribe(data => {
			this.StateList = [];
			data.forEach(item => {
				const a = item.payload.toJSON();
				a['$key'] = item.key;
				this.StateList.push(a as Auth);

			});
		});
	}

	userRegister() {
		this.editStudentForm = this.fb.group({
			fullName: ['', [Validators.required, Validators.minLength(5)]],
			schoolName: ['', Validators.required],
			bday: ['', Validators.required],
			suburb: ['', Validators.required],
			postalCode: ['', Validators.required],
			state: ['', Validators.required],
			email: [{value: '', disabled : true}],
			password: [{value: '', disabled : true}],
			status: ['', Validators.required],
			userType: ['', Validators.required],
			userId: ['']
		});
		this.editStudentForm.controls['email'].disable(); 
		this.editStudentForm.controls['password'].disable();
	}

	get e(): any {
		return this.editStudentForm.controls;
	}

	convertTextR() {
		if (this.encryptMode) {
			this.encryptPswdR = CryptoJS.AES.encrypt(this.editStudentForm.controls.password.value.trim(),
				this.editStudentForm.controls.email.value.trim()).toString();
		}
	}

	get email() {
		return this.editStudentForm.get('email');
	}

	get password() {
		return this.editStudentForm.get('password');
	}

	ResetForm() {
		this.editStudentForm.reset();
	}

	onUpdate(): void {
		this.submitted = true;
		if (this.editStudentForm.valid == true) {
			this.convertTextR();
			this.db.object('/user_register/' + this.actRoute.snapshot.paramMap.get('id')).update({
				fullName: this.e.fullName.value,
				schoolName: this.e.schoolName.value,
				bday: this.e.bday.value,
				suburb: this.e.suburb.value,
				postalCode: this.e.postalCode.value,
				state: this.e.state.value,
			});
			this.toastr.success(this.e['email'].value + ' updated successfully');
			this.router.navigate(['admin-user-list'])
		} else {
			this.toastr.error('Form is invalid');
		}
	}

}
